import { useFeatureGate } from "@statsig/react-bindings";
import { AdmissionFlow } from "../types";
import { VideoPlatform } from "../video-sdk/types";
import { telehealthManualAdmissionFlowGate } from "../statsig/gates";
import { useVideoPlatform } from "./useVideoPlatform";
import { useCallback } from "react";
import { Statsig } from "../statsig/StatsigProvider";

function getAdmissionFlow(
  videoPlatform: VideoPlatform | null,
  isManualAdmissionFlowEnabled: boolean,
): AdmissionFlow {
  return videoPlatform === VideoPlatform.Zoom && isManualAdmissionFlowEnabled
    ? "manual"
    : "auto";
}

/**
 * The client user checks this gate and relays their admission flow to the
 * provider side as part of their presence updates.
 */
export function useAdmissionFlow(): [AdmissionFlow, () => AdmissionFlow] {
  const { value: isManualAdmissionFlowEnabled } = useFeatureGate(
    telehealthManualAdmissionFlowGate,
  );
  const [videoPlatform, getVideoPlatform] = useVideoPlatform();
  const getAdmissionFlowCallback = useCallback(() => {
    return getAdmissionFlow(
      getVideoPlatform(),
      Statsig.checkGate(telehealthManualAdmissionFlowGate),
    );
  }, [getVideoPlatform]);

  return [
    getAdmissionFlow(videoPlatform, isManualAdmissionFlowEnabled),
    getAdmissionFlowCallback,
  ];
}
